import React, { useEffect, useState, useCallback } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Modal from '@omilia/modal';

import {
  getAccountsWithIds,
  getIsLoading,
  // @ts-ignore
} from 'store/services/accounts/selectors';
import {
  getAccounts,
  cancelGetAccounts,
  // @ts-ignore
} from 'store/services/accounts/actions';

import CreateProject from 'scenes/Projects/scenes/CreateProjectModal/scenes/CreateProject';
import ImportProject from 'scenes/Projects/scenes/CreateProjectModal/scenes/ImportProject';
import CloneProject from 'scenes/Projects/scenes/CreateProjectModal/scenes/CloneProject';
import NewProject from 'scenes/Projects/scenes/CreateProjectModal/scenes/NewProject';
import modalHelper from 'scenes/Projects/scenes/CreateProjectModal/scenes/utils/modalHelper';

import { PartialRootState } from 'store/services/accounts/types';
import { CreateProjectModalProps } from 'scenes/Projects/types';

const CreateProjectModal = ({
  match,
  history,
  accounts,
  isLoadingAccounts,
  projectsCount,
  getAccounts,
  cancelGetAccounts,
  onCloseRequest,
}: CreateProjectModalProps) => {
  const [selectedTypeProject, setSelectedTypeProject] = useState('');

  const goBack = useCallback(history.goBack, [history]);

  useEffect(() => {
    if (history.location.pathname === '/new') setSelectedTypeProject('');
  }, [history.location]);

  useEffect(() => {
    getAccounts();
  }, [getAccounts]);

  const { title, subtitle, glyph, onBackClick } = modalHelper({
    onGoBack: goBack,
    selectedTypeProject,
  });

  return (
    <Modal
      open
      shouldCloseOnBackdropClick
      shouldCloseOnEscPress
      glyph={glyph}
      subtitle={subtitle}
      title={title}
      onBackClick={onBackClick}
      onClose={onCloseRequest}
    >
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path={`${match.url}/create-project`}
            render={() => (
              <NewProject
                accounts={accounts}
                cancelGetAccounts={cancelGetAccounts}
                getAccounts={getAccounts}
                isLoadingAccounts={isLoadingAccounts}
                onCloseRequest={onCloseRequest}
                onSetProjectType={setSelectedTypeProject}
              />
            )}
          />

          <Route
            exact
            path={`${match.url}/import-project`}
            render={() => (
              <ImportProject
                accounts={accounts}
                cancelGetAccounts={cancelGetAccounts}
                getAccounts={getAccounts}
                isLoadingAccounts={isLoadingAccounts}
                onCloseRequest={onCloseRequest}
                onSetProjectType={setSelectedTypeProject}
              />
            )}
          />

          <Route
            exact
            path={`${match.url}/clone-project`}
            render={() => (
              <CloneProject
                accounts={accounts}
                cancelGetAccounts={cancelGetAccounts}
                getAccounts={getAccounts}
                isLoadingAccounts={isLoadingAccounts}
                projectsCount={projectsCount}
                onCloseRequest={onCloseRequest}
                onSetProjectType={setSelectedTypeProject}
              />
            )}
          />

          <Route>
            <CreateProject isLoading={isLoadingAccounts} />
          </Route>
        </Switch>
      </BrowserRouter>
    </Modal>
  );
};

const mapStateToProps = (state: PartialRootState) => ({
  accounts: getAccountsWithIds(state),
  isLoadingAccounts: getIsLoading(state),
});

export const mapDispatchToProps = {
  getAccounts,
  cancelGetAccounts,
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CreateProjectModal) as React.FC<CreateProjectModalProps>;
